import { useRouter } from 'next/router';

import { useMutation } from 'react-query';
import { companyUserManagementAcceptInvitation } from 'services/company';

import UseToast from 'hooks/use-toast';

import LinkButton from '@core/components/linkbutton/LinkButton';
import ActionButton from '@core/components/actionbutton/ActionButton';

import EmptyCompanyInv from 'assets/icons/folder-2.svg';

import classes from './CompanyLacking.module.scss';

const CompanyLacking = ({ data, refetch }) => {
	const router = useRouter();
	const { toast, ToastContainer } = UseToast();

	const { mutate: acceptInvitation } = useMutation(companyUserManagementAcceptInvitation.POST, {
		onSuccess: (data) => {
			toast(data.data.message, 'success');
			refetch && refetch();
		},
		onError: (error) => {
			toast(getErrorText(error), 'Alert');
		}
	});

	return (
		<>
			<div
				className={`${classes['company-lacking-wrapper']} container d-flex flex-column align-items-center justify-content-center gap-3 my-2 my-lg-5`}>
				{router.query.verification && (
					<h2 className="pb-2 pb-md-5">Your email address has now been verified.</h2>
				)}
				<h4>How do you want to enter Pharmuni?</h4>
				<p>
					Please note that you can enter Pharmuni business with each email from only one company.
				</p>
				<div
					className={`${classes['company-inv-wrapper']} d-flex flex-column align-items-center justify-content-center`}>
					<h5>Invitation from</h5>
					{data.company_invitations && data.company_invitations.length > 0 ? (
						<div className="d-flex flex-column align-items-center">
							{data.company_invitations.map((inv) => (
								<div
									className={`${classes['company-inv-cart']} d-flex flex-column flex-md-row justify-content-between align-items-center gap-4`}>
									<div className="d-flex flex-column flex-md-row gap-1">
										{inv.company_logo && <img src={inv.company_logo} alt={inv.company_name} />}
										<div>
											<div className="d-flex flex-column flex-md-row align-items-md-center gap-3 mb-3 mb-md-3">
												<h5>{inv.company_name}</h5>
												<p>
													Role: <span>{inv.role}</span>
												</p>
											</div>
											<p>Invited: {inv.invite_date}</p>
										</div>
									</div>
									<ActionButton
										onClick={() => acceptInvitation({ id: inv.id })}
										kind="secondary_main_light">
										Accept invitation
									</ActionButton>
								</div>
							))}
						</div>
					) : (
						<div
							className={`${classes['company-empty-inv']} d-flex flex-column align-items-center py-5 gap-3`}>
							<EmptyCompanyInv />
							<h5>No invitation yet!</h5>
							<p>
								If you want to join a specific company, ask the Pharmuni global admin of their
								company profile to invite you.
							</p>
						</div>
					)}
				</div>
				<div className={`${classes['dotted-divider']} my-3 my-5`}>
					<div>Or you can</div>
				</div>
				<LinkButton kind="secondary" className="p-3" to="/company/new">
					Complete Company Profile
				</LinkButton>
			</div>
			<ToastContainer />
		</>
	);
};

export default CompanyLacking;
